import axios from "shared/tools/axiosMultisite";
export default {
    state: () => ({
        showAddVariantToMyProductsModal: false,
        myProductsEditModalProductInfo: {},
    }),
    getters: {
        getShowAddVariantToMyProductsModal: (state) => {
            return state.showAddVariantToMyProductsModal;
        },
        getMyProductsEditModalProductInfo: (state) => {
            return state.myProductsEditModalProductInfo;
        },
    },
    mutations: {
        setShowAddVariantToMyProductsModal: (state, payload) => {
            if (!payload) {
                state.showAddVariantToMyProductsModal = false;
                state.myProductsEditModalProductInfo = {};
            }
            else
            {
                state.showAddVariantToMyProductsModal = payload.show;
                state.myProductsEditModalProductInfo = payload.productInfo;
            }
        },
    },
    actions: {
        addVariantToMyProducts: ({ commit, state }, payload) => {
            return axios.put('/api/consumeraccount/updatecreateconsumerproduct', payload)
        },
        removeVariantFromMyProducts: ({ commit }, code) => {
            return axios.delete('/api/consumeraccount/deleteconsumerproduct', {
                data: {
                    ProductId: code,
                }
            })
        },

    }
}
